/** Default rows per page when the consumer does not override `rowsPerPage`. */
export const DEFAULT_TABLE_ROWS_PER_PAGE = 15;

/**
 * Supported rows-per-page values for DataTable / `useDataTable` (e.g. footer select).
 * Pass one of these as the `rowsPerPage` prop on {@link DataTableView}.
 */
export const ROWS_PER_PAGE = [
  DEFAULT_TABLE_ROWS_PER_PAGE,
  25,
  50,
  100,
] as const;

export type RowsPerPageOption = (typeof ROWS_PER_PAGE)[number];
